// extracted by mini-css-extract-plugin
export default {"row":"Gvb5AlpRsPKh0yDXn3Ff"};